// Ask AI / AI Radar deep links (?ai_open, ?ai_locate, ?ai_page, ?ai_q,
// ?ai_hl, ?ai_return) open a document on the Drawings and Specifications
// pages. A page reads them once on load and must then take them OUT of the
// address (Larry K7-25, 2026-10-06): left in, closing the viewer — which
// steps back one history entry — made Turbo restore the page from that
// address, the link was read again, and the sheet reopened every time he
// closed it. Turbo's own history state is kept, so Back still works.
export const AI_LINK_PARAMS = ["ai_open", "ai_page", "ai_q", "ai_hl", "ai_locate", "ai_return"]

export function clearAiDeepLink(win = window) {
  let url
  try { url = new URL(win.location.href) } catch (_) { return false }
  if (!AI_LINK_PARAMS.some(k => url.searchParams.has(k))) return false
  AI_LINK_PARAMS.forEach(k => url.searchParams.delete(k))
  try {
    win.history.replaceState(win.history.state, "", url.pathname + url.search + url.hash)
  } catch (_) {
    return false
  }
  return true
}
